var angular = require('angular');
var _ = require('lodash');

var usTranslations = require('./i18n/en-US.json');
var daTranslations = require('./i18n/da-DK.json');
var deTranslations = require('./i18n/de-DE.json');
var elTranslations = require('./i18n/el-GR.json');
var esTranslations = require('./i18n/es-ES.json');
var fiTranslations = require('./i18n/fi-FI.json');
var frTranslations = require('./i18n/fr-FR.json');
var itTranslations = require('./i18n/it-IT.json');
var nbTranslations = require('./i18n/nb-NO.json');
var nlTranslations = require('./i18n/nl-NL.json');
var plTranslations = require('./i18n/pl-PL.json');
var ptTranslations = require('./i18n/pt-PT.json');
var ruTranslations = require('./i18n/ru-RU.json');
var svTranslations = require('./i18n/sv-SE.json');
var trTranslations = require('./i18n/tr-TR.json');

var translations = angular.module('ike.services.translations', ['ikeweb.shared.i18n']);

function registerTranslations($translateProvider, tmhDynamicLocaleService) {
    $translateProvider.translations('en-US', usTranslations);
    $translateProvider.translations('da-DK', _.merge(usTranslations, daTranslations));
    $translateProvider.translations('de-DE', _.merge(usTranslations, deTranslations));
    $translateProvider.translations('el-GR', _.merge(usTranslations, elTranslations));
    $translateProvider.translations('es-ES', _.merge(usTranslations, esTranslations));
    $translateProvider.translations('fi-FI', _.merge(usTranslations, fiTranslations));
    $translateProvider.translations('fr-FR', _.merge(usTranslations, frTranslations));
    $translateProvider.translations('it-IT', _.merge(usTranslations, itTranslations));
    $translateProvider.translations('nb-NO', _.merge(usTranslations, nbTranslations));
    $translateProvider.translations('nl-NL', _.merge(usTranslations, nlTranslations));
    $translateProvider.translations('pl-PL', _.merge(usTranslations, plTranslations));
    $translateProvider.translations('pt-PT', _.merge(usTranslations, ptTranslations));
    $translateProvider.translations('ru-RU', _.merge(usTranslations, ruTranslations));
    $translateProvider.translations('sv-SE', _.merge(usTranslations, svTranslations));
    $translateProvider.translations('tr-TR', _.merge(usTranslations, trTranslations));
};
var localeCache = {};
translations.config(['$translateProvider', registerTranslations]);
translations.run(['tmhDynamicLocaleCache', 'tmhDynamicLocale', function(tmhDynamicLocaleCache, tmhDynamicLocale) {

    function getInjectedLocale() {
        var localInjector = angular.injector(['ngLocale']);
        var locale = localInjector.get('$locale');
        localeCache[locale.id] = locale;
        return locale;
    }

    require('angular-i18n/en-us');
    tmhDynamicLocaleCache.put('en-US', localeCache['en-us'] || getInjectedLocale());
    require('angular-i18n/da-dk');
    tmhDynamicLocaleCache.put('da-DK', localeCache['da-dk'] || getInjectedLocale());
    require('angular-i18n/de-de');
    tmhDynamicLocaleCache.put('de-DE', localeCache['de-de'] || getInjectedLocale());
    require('angular-i18n/el-gr');
    tmhDynamicLocaleCache.put('el-GR', localeCache['el-gr'] || getInjectedLocale());
    require('angular-i18n/es-es');
    tmhDynamicLocaleCache.put('es-ES', localeCache['es-es'] || getInjectedLocale());
    require('angular-i18n/fi-fi');
    tmhDynamicLocaleCache.put('fi-FI', localeCache['fi-fi'] || getInjectedLocale());
    require('angular-i18n/fr-fr');
    tmhDynamicLocaleCache.put('fr-FR', localeCache['fr-fr'] || getInjectedLocale());
    require('angular-i18n/it-it');
    tmhDynamicLocaleCache.put('it-IT', localeCache['it-it'] || getInjectedLocale());
    require('angular-i18n/nb-no');
    tmhDynamicLocaleCache.put('nb-NO', localeCache['nb-no'] || getInjectedLocale());
    require('angular-i18n/nl-nl');
    tmhDynamicLocaleCache.put('nl-NL', localeCache['nl-nl'] || getInjectedLocale());
    require('angular-i18n/pl-pl');
    tmhDynamicLocaleCache.put('pl-PL', localeCache['pl-pl'] || getInjectedLocale());
    require('angular-i18n/pt-pt');
    tmhDynamicLocaleCache.put('pt-PT', localeCache['pt-pt'] || getInjectedLocale());
    require('angular-i18n/ru-ru');
    tmhDynamicLocaleCache.put('ru-RU', localeCache['ru-ru'] || getInjectedLocale());
    require('angular-i18n/sv-se');
    tmhDynamicLocaleCache.put('sv-SE', localeCache['sv-se'] || getInjectedLocale());
    require('angular-i18n/tr-tr');
    tmhDynamicLocaleCache.put('tr-TR', localeCache['tr-tr'] || getInjectedLocale());

    tmhDynamicLocale.set('en-US');
}]);



//////////////////
// WEBPACK FOOTER
// ./src/client/i18n.js
// module id = 602
// module chunks = 1